module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_5012.f0624d79.png";